import classNames from 'classnames'
import React from 'react'

import { Button, Heading } from '../../../components'
import { Table, TableBody, TableCell, TableRow } from '../../../components/Table'
import { IndividualManagers, InsiderView } from '../constants'
import { useInsiderTradingRouter } from '../hooks/useInsiderTradingRouter'

interface Props {
  individualManagers?: IndividualManagers
}

const SHARED_BUTTON_CLASSES = 'text-wrap border-none font-normal'

function IndividualManagersSection({ individualManagers }: Props) {
  const insiderTradingRouter = useInsiderTradingRouter<InsiderView.ManagerDetails>()

  if (!individualManagers) {
    return null
  }

  return (
    <div>
      <div className="mb-2 px-1.5">
        <Heading level={5}>Individual Managers</Heading>
      </div>
      {individualManagers.length === 0 ? (
        <span className="block px-1.5 text-2xs text-muted-2">
          There aro no other managers reporting in the combined 13F filing.
        </span>
      ) : (
        <Table className="styled-table-new">
          <TableBody>
            {individualManagers.map(({ name, investorId }, index) => (
              <TableRow key={index}>
                <TableCell className="pl-0">
                  <Button
                    {...(!investorId
                      ? {
                          as: 'span',
                          theme: 'transparent',
                          className: classNames(SHARED_BUTTON_CLASSES, 'text-muted-2'),
                        }
                      : {
                          as: 'a',
                          href: insiderTradingRouter.getInsiderTradingLink({
                            view: InsiderView.ManagerDetails,
                            params: { investorId, reportEndDate: insiderTradingRouter.viewParams.reportEndDate },
                          }),
                          theme: 'link',
                          className: SHARED_BUTTON_CLASSES,
                        })}
                    align="left"
                    title={name}
                    size="none"
                  >
                    {name}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  )
}

export default IndividualManagersSection
